import { DEFAULT_RX_IMAGE } from "@cart-ui/constants/MROCart";
import { DeliverySpeedDetail, MROChildCart, MROChildLocalCart, Option } from "@swiggy-private/cart-types";

export const getMROChildCartRestaurantName = (child?: MROChildCart | MROChildLocalCart): string => {
    return (child as MROChildCart)?.restaurant_details?.name || (child as MROChildLocalCart)?.restaurantName || "";
};

export const getMROChildCartRestaurantImageId = (child?: MROChildCart | MROChildLocalCart): string => {
    return child?.restaurant_details?.cloudinary_image_id || DEFAULT_RX_IMAGE;
};

export const getSelectedSlaFromSlaOptions = (
    slaOptions: Option[],
    selectedSlaOption: DeliverySpeedDetail | undefined,
): Option | undefined => {
    return slaOptions?.find((option) => option.option === selectedSlaOption?.type);
};
